import { setHtmlPageLang } from '@/plugins/vueI18n/helper';
import { LocaleType } from '@/store/locale';
import { useI18n } from 'vue-i18n';
import { fetchTolgeeTranslations, mergeTranslations } from 'vite-plugin-tolgee-i18n';

export const useLocale = () => {
    const { locale, setLocaleMessage } = useI18n();

    const changeLocale = async (localeType: LocaleType) => {
        // 先改变语言设置， 避免接口太慢导致的语言转换失败问题
        locale.value = localeType;

        const langModule = await import(`../locales/${localeType}.ts`);
        let messages = langModule.default;
        console.log(messages);
        if (import.meta.env.VITE_MODE !== 'prod') {
            const overrides = await fetchTolgeeTranslations(
                import.meta.env.VITE_APP_TOLGEE_API_URL || '',
                import.meta.env.VITE_TOGGLE_SECRET || '',
                localeType
            );
            if (overrides) {
                messages = mergeTranslations(messages, overrides);
            }
        }
        setLocaleMessage(localeType, messages);
        setHtmlPageLang(localeType);
    };

    return {
        changeLocale,
    };
};
